import { endOfDay, startOfDay } from 'date-fns';
import * as React from 'react';
import useMe from 'src/components/AuthContext/useMe';
import UserAvatarStack from 'src/components/molecules/UserAvatarStack';
import cn from 'src/lib/cn';
import { useCalendarPageContext } from '../../CalendarPageContext';
import Button from 'src/components/molecules/Button';
import usePromise from 'src/hooks/usePromise';
import useScreenSize from 'src/hooks/useScreenSize';

interface IProps {
  table: Odoo.Room;
  bookings: Odoo.Booking[];
  onSelect?: () => void;
  isActive?: boolean;
}

const DayTable: React.FC<IProps> = ({ table, bookings, onSelect, isActive }) => {
  const me = useMe();
  const { selectedDate, deleteBooking, createBooking, users } = useCalendarPageContext();
  const { isMobile } = useScreenSize();

  const { loading: deleting, run: runDeleteBooking } = usePromise(deleteBooking);
  const { loading: creating, run: runCreateBooking } = usePromise(createBooking);

  const handleCreateBooking = () => {
    runCreateBooking(startOfDay(selectedDate), endOfDay(selectedDate), table.id);
  };

  const myBooking = bookings.find(b => b.organizer_id[0] === me?.id);

  return (
    <div className={cn('day-table', { 'day-table--active': isActive })} onClick={onSelect}>
      <div className="day-table__title" data-id={table.id}>
        <span className="day-table__name">{table.name}</span>
        {isMobile && (
          <span className="day-table__mobile-bookings">{bookings.map(b => b.display_name).join(', ') || '-'}</span>
        )}
      </div>
      <div className="day-table__actions">
        {myBooking && (
          <Button
            variant="danger"
            loading={deleting}
            onClick={() => {
              runDeleteBooking(myBooking.id);
            }}
            data-key="cancel-booking"
          >
            {isMobile ? 'Cancel' : 'Cancel booking'}
          </Button>
        )}
        {bookings.length === 0 && (
          <Button data-key="create-booking" loading={creating} onClick={handleCreateBooking}>
            {isMobile ? 'Book' : 'Book this desk'}
          </Button>
        )}
        {bookings.length > 0 && (
          <>
            {!isMobile && <span>{bookings.map(b => b.display_name).join(', ')}</span>}
            {(!isMobile || !myBooking) && (
              <UserAvatarStack
                size="2"
                users={bookings.map(b => users.find(u => u.id === b.organizer_id[0])).filter(v => v != null)}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DayTable;
